import type { CategoryModel } from 'src/types/category';

import axios, { endpoints } from 'src/lib/axios';

export async function getCategories(): Promise<CategoryModel[]> {
  try {
    const response = await axios.get(endpoints.categories.getCategories);
    return response.data;
  } catch (error) {
    console.error('API error fetching categories:', error);
    throw error;
  }
}

export async function getCategory(id: number): Promise<CategoryModel> {
  try {
    const response = await axios.get(endpoints.categories.getCategory(id));
    return response.data;
  } catch (error) {
    console.error(`API error fetching category ${id}:`, error);
    throw error;
  }
}

export async function updateCategory(id: number, category: CategoryModel): Promise<CategoryModel> {
  try {
    const response = await axios.put(endpoints.categories.updateCategory(id), category);
    return response.data;
  } catch (error) {
    console.error(`API error updating category ${category.id}:`, error);
    throw error;
  }
}
